import { render, staticRenderFns } from "./TabAttachFilesTrackingDoc.vue?vue&type=template&id=2df2ba0c&"
import script from "./TabAttachFilesTrackingDoc.vue?vue&type=script&lang=js&"
export * from "./TabAttachFilesTrackingDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports